import { AssetListAsset } from 'src/@types/assets';
import { GenericAssetRenderingProps } from 'src/hooks/assets/types';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import { WRAPPED_SOL_MINT } from '@velocity-exchange/sdk';
import { useMemo } from 'react';
import { useAllWalletBalances } from 'src/hooks/query/walletBalances/useWalletBalance';

export function useWalletAssets<T extends AssetListAsset>(
	assetList: T[]
): GenericAssetRenderingProps<T>[] {
	const solBalance = useVelocityStore((s) => s.wallet.currentSolBalance);
	const walletBalances = useAllWalletBalances();

	const assetBalances = useMemo(
		() =>
			assetList.map((asset) => {
				if (asset.mint === WRAPPED_SOL_MINT.toBase58()) {
					return solBalance.toNum();
				}
				return walletBalances.get(asset.ticker)?.base.toNum() ?? 0;
			}),
		[assetList, solBalance, walletBalances]
	);

	return useMemo(
		() =>
			assetBalances.map((balance, index) => {
				return {
					...assetList[index],
					uiAmount: balance ?? 0,
				};
			}) as GenericAssetRenderingProps<T>[],
		[assetBalances, assetList]
	);
}
